<template>
  <div class="qcc-high-search-container">
    <!-- 直接嵌入企查查精准拓客高级搜索页面 -->
    <div style="height: calc(100vh - 120px);">
      <iframe
          id="qccHighSearchIframe"
          ref="qccHighSearchIframe"
          frameborder="0"
          style="width: 100%; height: 100%;"
          allowfullscreen
          v-loading="loading"
          element-loading-text="正在加载企查查高级搜索页面...">
      </iframe>
    </div>
  </div>
</template>

<script>
import {getToken} from '@/controller/supplier'

export default {
  name: 'QccHighSearch',
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.loadQccHighSearchPage()
  },
  methods: {
    // 加载企查查精准拓客高级搜索页面
    async loadQccHighSearchPage() {
      try {
        this.loading = true;

        // 调用后端API获取token
        const tokenResponse = await getToken({});
        if (tokenResponse && tokenResponse.code === '00') {
          const token = encodeURIComponent(tokenResponse.body.token);

          // 企查查提供的key（需要替换为实际的key）
          const qccKey = encodeURIComponent('60585352000c11f1b1c0b8cef6b42328');

          // returnUrl设置为/customer/customer-advance?hideBackFlag=Y
          const returnUrl = encodeURIComponent('/customer/customer-advance?hideBackFlag=Y');

          // 构建企查查URL（精准拓客高级搜索页面）
          const qccUrl = `https://pro-plugin.qcc.com/plugin-login?key=${qccKey}&token=${token}&returnUrl=${returnUrl}`;

          const iframe = this.$refs.qccHighSearchIframe;
          if (iframe) {
            // 监听iframe加载完成事件
            iframe.onload = () => {
              this.loading = false;
            };

            // 设置iframe源地址
            iframe.src = qccUrl;
          }
        } else {
          this.$message.error('获取企查查token失败');
          this.loading = false;
        }
      } catch (error) {
        console.error('加载企查查高级搜索页面失败:', error);
        this.$message.error('加载企查查高级搜索页面失败');
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss">
.qcc-high-search-container {
  padding: 20px;
  height: 100%;

  // 确保iframe容器占满可用空间
  > div {
    height: 100%;
  }
}
</style>
